/* ============================================================================
   PREMIUM — comportamento da loja
   ----------------------------------------------------------------------------
   Nenhuma dependência externa, nenhum build. Um objeto global `Premium`.

   Regra de ouro: quem calcula preço é a Shopify. Este arquivo só fala com
   /cart/*.js e repinta as seções que o servidor devolve. Nunca some, subtraia
   ou aplique desconto no navegador — o desconto do combo é um desconto
   automático configurado no admin e vem pronto na resposta do carrinho.
   ========================================================================== */
(function () {
  'use strict';

  var SECTIONS = 'cart-drawer,cart-bubble,mobile-bar';

  var Premium = {
    settings: window.PremiumSettings || {},

    /* ---------------------------------------------------------- utilidades */
    /* Formata centavos usando o money_format da loja. Só é usado para as
       tarifas devolvidas por /cart/shipping_rates.json — todo o resto já vem
       formatado do Liquid. */
    money: function (cents) {
      var fmt = this.settings.moneyFormat || 'R$ {{amount}}';
      var value = Number(cents) / 100;
      var comma = fmt.indexOf('amount_with_comma_separator') !== -1 || fmt.indexOf('R$') !== -1;
      var parts = value.toFixed(2).split('.');
      var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
      var body = comma ? int + ',' + parts[1] : int + '.' + parts[1];
      return fmt.replace(/\{\{\s*\w+\s*\}\}/, body).replace(/<[^>]*>/g, '').trim();
    },

    /* Texto que volta de um atributo e é reinserido como HTML passa por aqui. */
    esc: function (s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    },

    qs: function (sel, root) { return (root || document).querySelector(sel); },
    qsa: function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); },

    /* -------------------------------------------------------------- toast */
    _toastTimer: null,
    toast: function (msg) {
      var box = this.qs('#toast'), txt = this.qs('#toastMsg');
      if (!box || !txt) return;
      txt.textContent = msg;
      box.classList.add('on');
      clearTimeout(this._toastTimer);
      this._toastTimer = setTimeout(function () { box.classList.remove('on'); }, 2800);
    },

    /* ------------------------------------------------------ drawer e menus */
    openDrawer: function () {
      var d = this.qs('#drawer'); if (!d) return;
      d.classList.add('open');
      this.qs('#scrim').classList.add('on');
      document.body.style.overflow = 'hidden';
      document.body.classList.add('drawer-open');
      var close = this.qs('#drawer [data-close-cart]'); if (close) close.focus();
    },
    closeDrawer: function () {
      var d = this.qs('#drawer'); if (d) d.classList.remove('open');
      var m = this.qs('#msheet'); if (m) m.classList.remove('open');
      var s = this.qs('#scrim'); if (s) s.classList.remove('on');
      document.body.style.overflow = '';
      document.body.classList.remove('drawer-open');
    },
    openMenu: function () {
      this.qs('#msheet').classList.add('open');
      document.body.style.overflow = 'hidden';
      document.body.classList.add('drawer-open');
    },
    openModal: function (html) {
      var card = this.qs('#modalCard');
      card.innerHTML = '<button class="modal-x" data-close-modal aria-label="Fechar">✕</button>' + html;
      this.qs('#modal').classList.add('on');
      document.body.style.overflow = 'hidden';
    },
    closeModal: function () {
      this.qs('#modal').classList.remove('on');
      document.body.style.overflow = '';
    },

    /* ------------------------------------------------------------ carrinho */
    /* Repinta as seções devolvidas pelo servidor. Nada é recalculado aqui. */
    _paint: function (sections) {
      if (!sections) return;
      var map = {
        'cart-drawer': '#drawerInner',
        'cart-bubble': '#cartBubble',
        'mobile-bar': '#mbar'
      };
      Object.keys(map).forEach(function (name) {
        if (!sections[name]) return;
        var target = document.querySelector(map[name]);
        if (!target) return;
        var parsed = new DOMParser().parseFromString(sections[name], 'text/html');
        var fresh = parsed.querySelector(map[name]);
        if (!fresh) return;
        target.innerHTML = fresh.innerHTML;
        /* a classe carrega estado (contador escondido, barra vazia) */
        target.className = fresh.className;
      });
      document.dispatchEvent(new CustomEvent('premium:cart:updated'));
    },

    /* Uma requisição de carrinho por vez. Dois cliques rápidos no "+" mandavam
       duas vezes a MESMA quantidade (calculada na renderização anterior), e a
       segunda desfazia a primeira. */
    _busy: false,

    _post: function (url, body) {
      var self = this;
      if (this._busy) return Promise.reject(new Error('Aguarde um instante'));
      this._busy = true;
      body.sections = SECTIONS;
      body.sections_url = window.location.pathname;
      return this._fetch(url, body).then(
        function (d) { self._busy = false; return d; },
        function (e) { self._busy = false; throw e; }
      );
    },

    _fetch: function (url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'Não foi possível atualizar o carrinho');
          return data;
        });
      });
    },

    add: function (variantId, quantity, opts) {
      var self = this;
      opts = opts || {};
      return this._post('/cart/add.js', { items: [{ id: Number(variantId), quantity: quantity || 1 }] })
        .then(function (data) {
          self._paint(data.sections);
          if (!opts.silent) {
            self.toast(opts.message || 'Adicionado ao carrinho');
            self.openDrawer();
          }
          return self._refreshCartPage().then(function () { return data; });
        })
        .catch(function (err) { self.toast(err.message); throw err; });
    },

    /* Identificamos a linha pela chave do item, não pela posição. A posição
       muda quando outra linha é removida e o clique acaba caindo no vizinho. */
    changeLine: function (key, quantity) {
      var self = this;
      return this._post('/cart/change.js', { id: String(key), quantity: Number(quantity) })
        .then(function (data) {
          self._paint(data.sections);
          return self._refreshCartPage().then(function () { return data; });
        })
        .catch(function (err) { self.toast(err.message); throw err; });
    },

    /* Na página do carrinho, repinta o miolo sem recarregar a página inteira. */
    _refreshCartPage: function () {
      var page = this.qs('[data-cart-page]');
      if (!page) return Promise.resolve();
      return fetch(window.location.href, { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-page]');
          var target = Premium.qs('[data-cart-page]');
          if (fresh && target) target.innerHTML = fresh.innerHTML;
        })
        .catch(function () { window.location.reload(); });
    },

    /* A Section Rendering API devolve a seção embrulhada em
       <div id="shopify-section-…>. Tiramos o embrulho para o conteúdo herdar
       o layout de quem recebe (o .pick-grid da busca, por exemplo). */
    _unwrap: function (html, id) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var sec = doc.getElementById('shopify-section-' + id);
      return sec ? sec.innerHTML : html;
    },

    /* -------------------------------------------- seletor rápido (combo) */
    openPicker: function (handle) {
      var self = this;
      this.closeDrawer();
      this.openModal('<h3>Carregando…</h3>');
      fetch('/collections/' + encodeURIComponent(handle) + '?section_id=quick-picker')
        .then(function (r) {
          if (!r.ok) throw new Error('coleção não encontrada');
          return r.text();
        })
        .then(function (html) { self.openModal(self._unwrap(html, 'quick-picker')); })
        .catch(function () { self.openModal('<h3>Ops</h3><p>Não conseguimos abrir a lista agora. <a href="/collections/' + handle + '">Ver a coleção</a>.</p>'); });
    },

    pickSizes: function (btn) {
      var name = btn.getAttribute('data-name');
      var price = btn.getAttribute('data-price');
      var handle = btn.getAttribute('data-collection');
      var variants;
      try { variants = JSON.parse(btn.getAttribute('data-variants')); } catch (e) { variants = []; }
      var self = this;
      var chips = variants.map(function (v) {
        return v.available
          ? '<button class="size-chip" data-quick-add="' + Number(v.id) + '" data-close-after>' + self.esc(v.title) + '</button>'
          : '<button class="size-chip out" disabled>' + self.esc(v.title) + '</button>';
      }).join('');
      this.openModal(
        '<h3>' + this.esc(name) + '</h3>' +
        '<p style="color:var(--muted);font-size:13.5px">' + this.esc(price) + ' · escolha o tamanho</p>' +
        '<div class="sizes" style="margin-top:14px">' + chips + '</div>' +
        '<button class="btn btn-ghost btn-sm btn-wide" style="margin-top:16px" data-picker="' + this.esc(handle) + '">← Ver outros modelos</button>'
      );
    },

    /* ----------------------------------------------------------- busca */
    openSearch: function () {
      this.openModal(
        '<h3>Buscar</h3>' +
        '<div class="field" style="margin-top:12px"><label class="visually-hidden" for="qIn">Buscar produtos</label>' +
        '<input id="qIn" placeholder="Camiseta, boné, court…" autocomplete="off"></div>' +
        '<div id="qOut" class="pick-grid"></div>'
      );
      var input = this.qs('#qIn'); if (input) input.focus();
    },

    _searchTimer: null,
    doSearch: function (term) {
      var out = this.qs('#qOut'); if (!out) return;
      if (term.trim().length < 2) { out.innerHTML = ''; return; }
      clearTimeout(this._searchTimer);
      this._searchTimer = setTimeout(function () {
        fetch('/search?q=' + encodeURIComponent(term) + '&type=product&section_id=search-modal')
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            var out2 = Premium.qs('#qOut');
            if (out2) out2.innerHTML = html ? Premium._unwrap(html, 'search-modal') : '';
          })
          .catch(function () { /* busca é acessório: falhou, não mostra nada */ });
      }, 220);
    },

    /* --------------------------------------------------- consulta de CEP */
    quoteCep: function (rawCep, outEl) {
      var self = this;
      var cep = String(rawCep || '').replace(/\D/g, '');
      if (cep.length !== 8) {
        outEl.innerHTML = '<div class="cep-out"><b>CEP inválido.</b> Digite os 8 números.</div>';
        return;
      }
      outEl.innerHTML = '<div class="note">Consultando…</div>';

      var local = fetch('https://viacep.com.br/ws/' + cep + '/json/')
        .then(function (r) { return r.json(); })
        .catch(function () { return null; });

      var rates = fetch('/cart/shipping_rates.json?shipping_address%5Bzip%5D=' + cep + '&shipping_address%5Bcountry%5D=Brazil')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });

      Promise.all([local, rates]).then(function (res) {
        var place = res[0], quote = res[1];
        var head = (place && !place.erro && place.localidade)
          ? '<b>' + self.esc(place.localidade) + '/' + self.esc(place.uf) + '</b>'
          : '<b>CEP ' + self.esc(cep) + '</b>';
        var body;
        var list = quote && quote.shipping_rates ? quote.shipping_rates : null;

        if (list && list.length) {
          body = list.map(function (r) {
            var price = Number(r.price) === 0 ? 'Grátis' : self.money(Math.round(Number(r.price) * 100));
            return '<div>' + self.esc(r.name) + ' — <b>' + self.esc(price) + '</b></div>';
          }).join('');
        } else {
          body = '<div>Frete calculado no checkout. Frete grátis nos pedidos acima de ' +
                 self.money(self.settings.freeShipping || 0) + '.</div>';
        }
        outEl.innerHTML = '<div class="cep-out">' + head + body + '</div>';
      });
    }
  };

  /* ==========================================================================
     Delegação de eventos. Tudo que o HTML dispara passa por aqui.
     ====================================================================== */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-cart],[data-close-cart],[data-open-menu],[data-close-menu],' +
      '[data-close-modal],[data-picker],[data-pick-product],[data-quick-add],[data-line-change],' +
      '[data-open-search],[data-size],[data-card-sizes],[data-size-guide],[data-cep-go]');
    if (!t) return;

    /* um link com data-close-cart fecha o painel E navega: não bloqueie o href */
    var isLink = t.tagName === 'A' && t.getAttribute('href');

    if (t.hasAttribute('data-open-cart')) { e.preventDefault(); Premium.openDrawer(); return; }
    if (t.hasAttribute('data-close-cart')) { if (!isLink) e.preventDefault(); Premium.closeDrawer(); return; }
    if (t.hasAttribute('data-open-menu')) { e.preventDefault(); Premium.openMenu(); return; }
    if (t.hasAttribute('data-close-menu')) { if (!isLink) e.preventDefault(); Premium.closeDrawer(); return; }
    if (t.hasAttribute('data-close-modal')) { e.preventDefault(); Premium.closeModal(); return; }
    if (t.hasAttribute('data-open-search')) { e.preventDefault(); Premium.openSearch(); return; }

    if (t.hasAttribute('data-picker')) {
      e.preventDefault();
      Premium.openPicker(t.getAttribute('data-picker'));
      return;
    }
    if (t.hasAttribute('data-pick-product')) { e.preventDefault(); Premium.pickSizes(t); return; }

    /* adiciona direto pela variante (seletor rápido, addon, card) */
    if (t.hasAttribute('data-quick-add')) {
      e.preventDefault();
      var closeAfter = t.hasAttribute('data-close-after');
      t.classList.add('loading');
      Premium.add(t.getAttribute('data-quick-add'), 1, { message: t.getAttribute('data-message') || undefined })
        .then(function () { if (closeAfter) Premium.closeModal(); })
        .catch(function () { /* o toast já avisou o cliente */ })
        .then(function () { t.classList.remove('loading'); });
      return;
    }

    /* + / − / remover no carrinho e no drawer */
    if (t.hasAttribute('data-line-change')) {
      e.preventDefault();
      t.classList.add('loading');
      Premium.changeLine(t.getAttribute('data-key'), t.getAttribute('data-qty'))
        .catch(function () { /* o toast já avisou o cliente */ })
        .then(function () { t.classList.remove('loading'); });
      return;
    }

    /* chip de tamanho na PDP */
    if (t.hasAttribute('data-size')) {
      e.preventDefault();
      var form = t.closest('[data-product-form]');
      if (!form) return;
      Premium.qsa('[data-size]', form).forEach(function (b) { b.classList.remove('sel'); });
      t.classList.add('sel');
      var idInput = Premium.qs('[name="id"]', form);
      if (idInput) idInput.value = t.getAttribute('data-variant-id');
      var hint = Premium.qs('[data-size-hint]', form);
      if (hint) hint.innerHTML = 'Tamanho <b>' + Premium.esc(t.textContent.trim()) + '</b> selecionado';
      var submit = Premium.qs('[data-add-button]', form);
      if (submit) { submit.disabled = false; }
      return;
    }

    /* card: revelar tamanhos */
    if (t.hasAttribute('data-card-sizes')) {
      e.preventDefault();
      var card = t.closest('.card');
      var box = Premium.qs('[data-card-cta]', card);
      var data;
      try { data = JSON.parse(t.getAttribute('data-variants')); } catch (err) { data = []; }
      box.innerHTML = '<div class="sizes">' + data.map(function (v) {
        return v.available
          ? '<button class="size-chip" data-quick-add="' + Number(v.id) + '">' + Premium.esc(v.title) + '</button>'
          : '<button class="size-chip out" disabled>' + Premium.esc(v.title) + '</button>';
      }).join('') + '</div><div class="size-hint" style="margin-top:5px">Toque no tamanho para adicionar</div>';
      return;
    }

    if (t.hasAttribute('data-size-guide')) {
      e.preventDefault();
      var tpl = document.getElementById(t.getAttribute('data-size-guide'));
      if (tpl) Premium.openModal(tpl.innerHTML);
      return;
    }

    if (t.hasAttribute('data-cep-go')) {
      e.preventDefault();
      var wrapper = t.closest('[data-cep-block]');
      Premium.quoteCep(Premium.qs('[data-cep-input]', wrapper).value, Premium.qs('[data-cep-out]', wrapper));
      return;
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target.id === 'qIn') Premium.doSearch(e.target.value);
  });

  /* formulário de produto: envia por AJAX e abre o drawer */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var idInput = Premium.qs('[name="id"]', form);
    var hint = Premium.qs('[data-size-hint]', form);
    if (!idInput || !idInput.value) {
      if (hint) hint.innerHTML = '<b>Escolha um tamanho antes de continuar</b>';
      var sizes = Premium.qs('[data-sizes]', form);
      if (sizes) sizes.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }
    var btn = Premium.qs('[data-add-button]', form);
    if (btn) btn.classList.add('loading');
    Premium.add(idInput.value, 1, { message: form.getAttribute('data-added-message') || undefined })
      .catch(function () { /* o toast já avisou o cliente */ })
      .then(function () { if (btn) btn.classList.remove('loading'); });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { Premium.closeDrawer(); Premium.closeModal(); }
  });

  document.addEventListener('click', function (e) {
    if (e.target.id === 'modal') Premium.closeModal();
    if (e.target.id === 'scrim') Premium.closeDrawer();
    /* qualquer link do menu mobile fecha a folha ao navegar */
    if (e.target.closest('#msheet a')) Premium.closeDrawer();
  });

  /* galeria da PDP */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-gallery]');
    Premium.qsa('[data-thumb]', gallery).forEach(function (b) { b.classList.remove('on'); });
    Premium.qsa('[data-slide]', gallery).forEach(function (s) { s.classList.remove('on'); });
    thumb.classList.add('on');
    var target = Premium.qs('[data-slide="' + thumb.getAttribute('data-thumb') + '"]', gallery);
    if (target) target.classList.add('on');
  });

  /* ordenação da coleção */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-sort]')) e.target.form.submit();
  });

  /* ==========================================================================
     Carrossel: rolagem nativa. As setas só empurram o scroll e ligam/desligam
     nas pontas. Nada de biblioteca, nada de clonar slide.
     ====================================================================== */
  function carouselTrack(id) { return document.querySelector('[data-carousel="' + id + '"]'); }

  function syncCarousel(track) {
    if (!track) return;
    var id = track.getAttribute('data-carousel');
    var prev = document.querySelector('[data-carousel-prev="' + id + '"]');
    var next = document.querySelector('[data-carousel-next="' + id + '"]');
    var max = track.scrollWidth - track.clientWidth - 2;
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-carousel-prev],[data-carousel-next]');
    if (!btn) return;
    e.preventDefault();
    var back = btn.hasAttribute('data-carousel-prev');
    var track = carouselTrack(btn.getAttribute(back ? 'data-carousel-prev' : 'data-carousel-next'));
    if (!track) return;
    var card = track.firstElementChild;
    var step = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    var pages = Math.max(1, Math.floor(track.clientWidth / step));
    track.scrollBy({ left: (back ? -1 : 1) * step * pages, behavior: 'smooth' });
  });

  Premium.qsa('[data-carousel]').forEach(function (track) {
    syncCarousel(track);
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () { syncCarousel(track); });
    }, { passive: true });
  });
  window.addEventListener('resize', function () {
    Premium.qsa('[data-carousel]').forEach(syncCarousel);
  }, { passive: true });

  /* Header acompanha a rolagem (position:sticky no CSS). Aqui só marcamos o
     estado para a sombra aparecer quando a página sai do topo. */
  (function stickyHeader() {
    var header = document.querySelector('.hdr');
    if (!header) return;
    var ticking = false;
    function update() {
      header.classList.toggle('scrolled', window.scrollY > 8);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }, { passive: true });
    update();
  })();

  window.Premium = Premium;
})();
